<template>
    <div class="setting-box">
        <div class="setting-title">选项设置</div>
        <div class="setting-content">
            <div class="setting-content-item item-row">
                <span>选项随机显示</span>
                <el-switch v-model="dataList.isRandom" class="ml-2" />
            </div>
            <div class="setting-content-item item-row">
                <span
                    >选项排列
                    <el-tooltip
                        class="box-item"
                        effect="customized"
                        content="排序只针对电脑端设置生效，移动端不受此控制（注：移动端默认只显示纵向排列样式 ）。"
                        placement="top"
                    >
                        <svg-icon name="tips" class="icon" />
                    </el-tooltip>
                </span>
                <el-radio-group v-model="dataList.array" size="small">
                    <el-radio-button label="1">1列</el-radio-button>
                    <el-radio-button label="2">2列</el-radio-button>
                    <el-radio-button label="3">3列</el-radio-button>
                </el-radio-group>
            </div>
            <div class="setting-content-item">
                <span>答题选择</span>
                <div class="item-row">
                    <span>最多选择</span>
                    <el-select v-model="dataList.maxChoiceNum" class="m-2" placeholder="Select" size="large">
                        <el-option v-for="item in maxChoiceList" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>
                </div>
                <div class="item-row">
                    <span>最少选择</span>
                    <el-select v-model="dataList.minChoiceNum" class="m-2" placeholder="Select" size="large">
                        <el-option v-for="item in minChoiceList" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup name="kr-multiple-choice-setting">
const props = defineProps({
    dataList: {
        type: Object,
        default: () => ({}),
    },
});
const maxChoiceList = [
    { label: "不限制", value: "" },
    { label: "3", value: "3" },
    { label: "2", value: "2" },
    { label: "1", value: "1" },
];
const minChoiceList = [
    { label: "1", value: "1" },
    { label: "2", value: "2" },
    { label: "3", value: "3" },
];
</script>
<style lang="scss" scoped>
@import "@/css/setting.scss";
.item-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .icon {
        cursor: pointer;
        font-size: 16px;
    }
    span {
        flex-shrink: 0;
    }
}

:deep(.el-select--large) {
    width: 100%;
    position: relative;
    margin-left: 6px;
}
:deep(.el-select-dropdown__item) {
    line-height: 44px;
}
</style>
